const name = 'laptopLending';
const laptopsPath = 'laptops';
const loansPath = 'laptop-loans';
const settingsPath = 'laptop-settings';

export default {
  getLaptops: {
    name: 'laptops',
    path: laptopsPath,
    defaultValue: []
  },
  getLaptopById: {
    name: 'laptop',
    path: `${laptopsPath}/:laptopId`
  },
  getAvailableLaptops: {
    name: 'availableLaptops',
    path: `${laptopsPath}/available/:branchId`,
    defaultValue: []
  },
  createLaptop: {
    method: 'POST',
    path: laptopsPath
  },
  updateLaptop: {
    method: 'PUT',
    path: `${laptopsPath}/:laptopId`
  },
  retireLaptop: {
    method: 'POST',
    path: `${laptopsPath}/:laptopId/retire`
  },
  transferLaptop: {
    method: 'POST',
    path: `${laptopsPath}/:laptopId/transfer`
  },
  getAccessoryTypes: {
    name: 'accessoryTypes',
    path: `${laptopsPath}/types/accessories`,
    defaultValue: []
  },
  getSpecificationTypes: {
    name: 'specificationTypes',
    path: `${laptopsPath}/types/specifications`,
    defaultValue: []
  },
  getLoans: {
    name: 'laptopLoans',
    path: loansPath,
    defaultValue: []
  },
  getLoanById: {
    name: 'laptopLoan',
    path: `${loansPath}/:loanId`
  },
  getStudentLoanHistory: {
    name: 'studentLoanHistory',
    path: `${loansPath}/student/:studentId/history`,
    defaultValue: []
  },
  getActiveLoanForStudent: {
    name: 'activeLoan',
    path: `${loansPath}/student/:studentId/active`
  },
  issueLaptop: {
    method: 'POST',
    path: `${loansPath}/issue`
  },
  returnLaptop: {
    method: 'POST',
    path: `${loansPath}/:loanId/return`
  },
  getSettings: {
    name: 'laptopSettings',
    path: settingsPath,
    defaultValue: []
  },
  updateSettings: {
    method: 'PUT',
    path: settingsPath
  },
  recordAcknowledgment: {
    method: 'POST',
    path: `${loansPath}/:loanId/acknowledge`
  },
  addLoanPhoto: {
    method: 'POST',
    path: `${loansPath}/:loanId/photos`
  },
  addMaintenanceLog: {
    method: 'POST',
    path: `${laptopsPath}/:laptopId/maintenance`
  },
  getMaintenanceLogs: {
    name: 'maintenanceLogs',
    path: `${laptopsPath}/:laptopId/maintenance`,
    defaultValue: []
  },
  getBranches: {
    name: 'branches',
    path: 'branches',
    defaultValue: []
  }
};
